// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    width: 100%;
    height: calc(100vh);
    padding-top: 105px;
    padding-bottom: 60px;
    overflow: hidden;
    background-color: var(--color-black);
    position: relative;
}

.main.notheader {
    padding-top: 20px;
}

.main-box {
    width: 100%;
    height: 100%;
    padding: 15px 20px;
    border-top-right-radius: 35px;
    border-top-left-radius: 35px;
    border-top: 2px solid var(--main-color);
    position: relative;
    box-shadow: 0px 3px 40px 10px var(--main-color-light);
    z-index: 100;
}

.main-1 {
    width: 100%;
    font-size: 14px;
}

.main-1-1 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.main-ads {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 10px;
    /* padding: 10px;
    height: 90px; */
    font-size: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
}

.main-2 {
    width: 100%;
    /* padding-top: 30px; */
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    height: calc(100vh - 290px);
}

.img_diamond {
    width: 30px;
}

.main-2-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 24px;
}

@keyframes bounceIn {
    0% {
        transform: translateY(-40px);
        /* 화면 위에서 시작 */
        opacity: 0;
        /* 투명하게 시작 */
    }

    70% {
        transform: translateY(10px);
        opacity: 1;
        /* 살짝 튕기듯 위로 올라감 */
    }

    100% {
        transform: translateY(0);
        /* 최종 위치에 도달 */
    }
}

/* .main-2-header.aos-animate {
    animation: bounceIn .2s ease-out;
} */

.main-2-img {
    position: relative;
    padding: 0;
    /* padding: 10px 15px 0; */
}

.center-img {
    outline: none;
    -webkit-tap-highlight-color: transparent;
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
}

.heart {
    position: absolute;
    width: 30px;
    height: 30px;
    animation: floatUp 1s ease-in-out forwards;
    z-index: 11;
    pointer-events: none;
}

.heart.number {
    font-size: 30px;
    font-weight: bold;
}

/* 위로 떠오르는 애니메이션 */
@keyframes floatUp {
    0% {
        opacity: 1;
        transform: translateY(0);
    }

    100% {
        opacity: 0;
        transform: translateY(-100px);
    }
}

.main-3 {
    width: 100%;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    position: fixed;
    left: 0;
    bottom: 75px;
    padding: 5px 30px;
}

.main-3-1 {
    display: flex;
    align-items: center;
    justify-content: center;
}

.main-3-1-img {
    width: 25px;
}

.page-img {
    width: 100%;
}

.hamster-img {
    width: 50%;
    min-width: 180px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    pointer-events: none;
}


.settings {
    padding: 0 15px;
    width: 100%;
}

.settings-header {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 10px;
}

.settings-list {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 15px;
    margin-bottom: 10px;
    height: 55px;
    padding: 0 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
}

.settings-list.active {
    border: 1px solid var(--color-light-gray);
}

.settings-list.disable {
    filter: blur(2px);
}

.settings-list-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
}

.settings-list-text1 {
    color: var(--color-white);
    font-weight: 500;
    font-size: 13px;
}

.settings-list-text2 {
    font-size: 12px;
    color: var(--color-light-gray);
}

.settings-list-text3 {
    color: var(--color-white);
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: left;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.settings-list-text3.active {
    background-color: var(--color-dark-gray);
    border-radius: 15px;
}

.settings-list-download {
    width: 100%;
    height: 100px;
    background-color: var(--color-white);
    border-radius: 15px;
    padding: 5px;
    text-align: left;
    position: relative;
    display: flex;
}

.settings-toggle {
    width: 100%;
    height: 40px;
    padding: 0 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
}

.toggle-box {
    display: inline-flex;
    align-items: center;
    justify-content: end;
}

.toggle-box-on {
    position: absolute;
    color: var(--color-white);
    top: 50%;
    left: 16px;
    transform: translateY(-50%);
}

.toggle-box-off {
    position: absolute;
    color: var(--color-darkest-gray);
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
}

.toggle-box {
    width: 45px;
    height: 22px;
    display: block;
    position: relative;
    border-radius: 30px;
    color: var(--color-white);
    background: var(--color-light-gray-bg);
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
}

.toggle-box-btn {
    transition: all .2s ease-in-out;
    width: 19px;
    height: 19px;
    position: absolute;
    top: 50%;
    left: 2px;
    transform: translateY(-50%);
    border-radius: 50%;
    background: var(--main-color-accent);
}

.toggled {
    background-color: var(--main-color-accent);
}

.toggled .toggle-box-btn.slider {
    transition: all .2s ease-in-out;
    left: calc(100% - 22px);
    background: var(--color-white);
}

.settings-subheader {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
}

.memories-list {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 8px 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.memories-list-text {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    font-size: 14px;
}

.settings-body {
    width: 100%;
    height: calc(100vh - 180px);
    overflow: scroll;
}

.friend {
    padding: 0 15px;
    width: 100%;
    height: 100%;
    /* padding-bottom: 75px; */
    overflow: scroll;
}

.memories {
    padding: 0 15px 25px;
    width: 100%;
    height: calc(100vh - 63px);
    overflow: scroll;
}

.airdrop-body {
    width: 100%;
    height: calc(100vh - 60px);
    padding-top: 400px;
    overflow: auto;
    padding: 0 15px 10px;
}

.memories-body {
    width: 100%;
    height: calc(100vh - 180px);
    overflow: scroll;
}

.airdrop-tab {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--color-dark-gray);
    padding: 5px;
    height: 50px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.airdrop-tab-item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    font-size: 13px;
    font-weight: 500;
}

.airdrop-tab-item.active {
    background-color: var(--color-charcoal);
}

.airdrop-input {
    width: 100%;
    background-color: var(--color-dark-gray);
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}

.airdrop-input-box-1 {
    width: 100%;
    text-align: left;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
}

.airdrop-input-box-2 {
    display: flex;
    align-items: center;
    gap: 10px;
}

.airdrop-input-box-2-1 {
    background-color: inherit;
    outline: none;
    color: var(--color-white);
    padding: 0 10px;
    border: 1px solid var(--color-gray);
    height: auto;
    /* 높이를 내용에 따라 자동 조정 */
    min-height: 30px;
    /* 최소 높이 설정 */
    border-radius: 5px;
    width: calc(100%);
    /* 100% 너비 */
    font-size: 12px;
    line-height: 30px;
    /* 줄 높이 */
    white-space: normal;
    /* 텍스트 줄바꿈 허용 */
    word-break: break-word;
    /* 단어 단위로 줄바꿈 */
}

.airdrop-box {
    width: 100%;
    padding: 25px 20px;
    background-color: var(--color-dark-gray);
    margin-bottom: 20px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.airdrop-box-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 20px;
    font-size: 13px;
    gap: 12px;
    font-weight: 500;
}

.airdrop-box-item .dots {
    height: 100%;
    flex-grow: 1;
    border-bottom: 2px dotted var(--color-gray);
}

.airdrop-box-item .number {
    font-size: 20px;
    font-weight: 500;
}

.airdrop-box-list {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 10px 20px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.airdrop-list-text {}

.airdrop-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 15px;
    font-size: 27px;
    color: var(--color-gray);
}

.airdrop-list-text2 {
    display: flex;
    align-items: center;
}

.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--color-black-opacity);
    z-index: 10000;
}

.modal-background {
    width: 100%;
    height: 100%;
}

.airdrop-modal {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 40px 15px 20px;
    background-color: var(--color-charcoal);
    z-index: 10;

    border-top-right-radius: 35px;
    border-top-left-radius: 35px;
    border-top: 2px solid var(--main-color);
    box-shadow: 0px 0px 70px 10px var(--main-color-light);
}

.modal-x {
    position: absolute;
    top: 12px;
    right: 20px;
    font-size: 23px;
    color: var(--color-gray);
}

.modal-airdrop-btn {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background-color: var(--main-color-alt);
    display: flex;
    align-items: center;
    justify-content: center;
}

.character {
    width: 100%;
    height: 100%;
    border-top: 2px solid var(--main-color);
    position: relative;
    background-color: var(--color-charcoal);
    box-shadow: 0px 3px 40px 10px var(--main-color-light);
    border-top-right-radius: 35px;
    border-top-left-radius: 35px;
    padding: 15px;
    display: flex;
    gap: 10px;
    z-index: 100;
}

.character-left {
    width: 70%;
}

.character-left-top {
    padding: 10px;
    height: calc(100vh - 350px);
    display: flex;
    align-items: center;
    justify-content: center;
}

.character-left-top img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: var(--color-charcoal);
}

.character-left-bottom {
    width: 100%;
    padding: 10px;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
}

.charcter-left-btn {
    width: 100%;
    height: 60px;
    background-color: var(--main-color-dark);
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 500;
}

.character-right {
    width: 30%;
    /* min-width: 100px; */
}

.character-grid {
    display: grid;
    box-sizing: border-box;
    grid-template-columns: 1fr;
    /* 두 열 고정 비율 */
    gap: 7px;
    overflow-y: auto;
    height: auto;
    max-height: calc(100vh - 200px);
    padding-top: 5px;
    padding-right: 5px;
}

.character-card {
    position: relative;
    background-color: var(--color-dark-gray);
    border-radius: 10px;
    padding: 15px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    color: var(--color-white);
}

.character-card.active {
    border: 1px solid var(--main-color-light);
}

.character-image {
    width: 80%;
    margin-bottom: 8px;
}

.character-name {
    font-size: 10px;
    color: var(--color-light-gray);
    font-weight: 500;
}

.lock-icon {
    position: absolute;
    top: -5px;
    right: -2px;
    font-size: 15px;
    color: var(--color-light-gray);
}

.lock-check {
    position: absolute;
    top: -5px;
    right: -5px;
    font-size: 15px;
}

.friend-list-text {}

.friend-list-text-1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
}

.friend-list {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 8px 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 30px;
}

.friend-list-1 {}

.friend-list-1-1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
}

.friend-list-1-2 {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 8px 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70px;
    font-weight: 500;
    color: var(--color-light-gray);
}

.friend-list-1-3 {
    width: 100%;
    background-color: var(--color-dark-gray);
    border-radius: 20px;
    margin-bottom: 10px;
    padding: 8px 15px;
    text-align: left;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* height: 70px; */
    font-weight: 500;
}

.friend-list-1-3-1 {
    display: flex;
    align-items: center;
    gap: 10px;
}

.friend-list-1-3-2 {
    display: flex;
    align-items: center;
    gap: 5px;
}

.friend-list-2 {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 30px);
    display: flex;
    align-items: center;
    gap: 7px;
}

.friend-list-2-1 {
    width: calc(100% - 50px);
    display: flex;
    align-items: center;
    justify-content: center;

}

.friend-list-2-btn {
    width: calc(100% - 10px);
    height: 45px;
    border-radius: 15px;
    background-color: var(--main-color-light);
    display: flex;
    align-items: center;
    justify-content: center;
}

.friend-list-2-icon {
    width: 50px;
    height: 45px;
    border-radius: 15px;
    background-color: var(--main-color-accent);
    display: flex;
    align-items: center;
    justify-content: center;
}

.setting-sns {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
}


.table-overflow-hidden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block !important;
}

.table-overflow-1line {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.table-overflow-2lines {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
}

.random {
    width: calc(100% - 80px);
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
}

.random .random-buttons {
    display: flex;
    justify-content: space-around;
    width: 100%;
}

.random .random-button {
    padding: 10px 30px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    width: calc(100% - 20px);
    height: 45px;
    color: var(--color-black);
    background-color: var(--main-color-light);
}

.random .random-button.disable {
    background-color: var(--color-light-gray);
}

.item-previews {
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
    gap: 4px;
    overflow: hidden;
    width: 100%;
}

.random-item {
    width: 100%;
    height: 100px;
    padding: 10px 15px;
    font-size: 16px;
    text-align: center;
    color: var(--color-white);
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
}

.random-item.selected {
    border: 1px solid var(--color-yellow);
    background-color: var(--color-black-brown);
}

.random-info {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.randombox-bg {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 0;
    object-fit: cover;
    border-radius: 50px;
    filter: grayscale(0.5);
}

.main-box-randombox {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
    top: 0;
    background-color: var(--color-black);
    display: flex;
}

.randombox-clear {
    padding: 30px 15px;
    width: 100%;
    height: 100%;
    overflow: scroll;
    background-color: var(--color-black-opacity-dark);
}

.randombox-clear-1 {
    background-color: var(--color-black-opacity-light);
    border: 2px solid var(--color-orange);
    border-radius: 10px;
    width: 95px;
    height: 90px;
    margin: 80px auto 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
}

.video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
    position: fixed;
    z-index: 1000;
    top: -7%;
    left: 50%;
    transform: translateX(-50%);
}






.coupons-tab {
    display: flex;
    gap: 15px;
    font-size: 15px;
}

.coupons-tab-btn {
    padding: 5px 0;
    cursor: pointer;
    color: #666;
    font-weight: bold;
    position: relative;
}

.coupons-tab-btn.active {
    color: #000;
    /* 밑줄 대신 노란색 바 */
    border-bottom: 2px solid #ffbb3f;
}

/* 스크롤 영역 */
.coupons-grid-scroll {
    max-height: calc(100dvh - 150px);
    overflow-y: auto;
}

/* 2열 그리드 */
.coupons-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 7px;
    padding-bottom: 60px;
}

.coupon-item {
    background-color: #fff;
    overflow: hidden;
    transition: opacity 0.3s;
    display: flex;
    flex-direction: column;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

.coupon-image-wrapper {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    /* 1:1 정사각형 비율 */
    overflow: hidden;
}

.coupon-image-wrapper.used {
    opacity: 0.6;
    /* 사용완료/사용불가 시 흐리게 */
}

.d-day-badge {
    position: absolute;
    background: #a0a0a0;
    /* 회색 배경 */
    color: #fff;
    padding: 3px 6px;
    font-size: 12px;
    font-weight: bold;
    z-index: 2;
    top: 1px;
    left: 1px;
}

.coupon-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 1px solid #f9f9f9;
    border-radius: 5px;
}

/* 사용완료/사용불가 구분 */
.used-type-badge {
    position: absolute;
    bottom: 5px;
    right: 5px;
    padding: 3px 6px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #fff;
    z-index: 2;
}

.used-type-badge.complete {
    background: rgba(128, 128, 128, 0.7);
}

.used-type-badge.not-available {
    background: rgba(255, 0, 0, 0.7);
}

.coupon-info {
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.coupon-company {
    font-size: 13px;
    font-weight: 500;
    color: #79a2c9;
    width: 100%;
    text-align: left;
}

.coupon-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 7px;
    color: #919191;
    width: 100%;
    text-align: left;
}

.coupon-from {
    font-size: 14px;
    color: #000;
    font-weight: bold;
    width: 100%;
    text-align: left;
}

.coupon-date {
    font-size: 11px;
    color: #9b9b9b;
    width: 100%;
    text-align: left;
}

.shopping-nav {
    margin-top: 50px;
    background-color: #fff;
    border-bottom: 1px solid #dddddd;
}

.shopping-nav ul {
    display: flex;
    overflow-x: auto;
    margin: 0;
    padding: 0 10px;
    list-style-type: none;
    gap: 10px;
}

.shopping-nav li {
    padding: 10px 6px;
    white-space: nowrap;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
}

.shopping-nav li.active {
    border-bottom: 2px solid #000;
}

.tab-container {
    display: flex;
    justify-content: center;
    background-color: #f1f1f1;
    padding: 2px;
    border-radius: 30px;
    width: fit-content;
    margin: 0px auto 15px;
}

.tab-button {
    padding: 7px 0px;
    border: none;
    background-color: transparent;
    border-radius: 30px;
    font-size: 14px;
    color: #555;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    width: 100px;
    height: 34px;
}

.tab-button.active {
    background-color: white;
    color: black;
    font-weight: 700;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);
}

.gift-scroll-container {
    width: 100%;
    background: #f5f5f5;
    padding: 15px 15px;
}

.gift-scroll-container::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari */
}

.category-slide-wrapper {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    gap: 12px;
}

.category-slide {
    flex: 0 0 auto;
    width: 100%;
    height: 250px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(3, 70px);
    gap: 18px 5px;
    scroll-snap-align: start;
}

.category-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 13px;
    color: #222;
    cursor: pointer;
    margin: 0 auto;
    max-width: 60px;
}

.category-item img {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 40%;
    margin-bottom: 5px;
    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
    /* background-color: #f5f5f5; */
    border: 1px solid #f9f9f9;
    padding: 2px;
}

.brand-scroll-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    grid-auto-flow: column;
    grid-template-rows: repeat(2, auto);
    overflow-x: auto;
    gap: 16px 12px;
    padding: 10px 12px;
    scroll-snap-type: x mandatory;
}

.brand-slide-wrapper {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    gap: 16px;
}

.brand-slide {
    flex: 0 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 54px);
    gap: 10px 10px;
    scroll-snap-align: start;
    width: 100%;
}

.brand-list-slide {
    flex: 0 0 auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 54px);
    gap: 7px 10px;
    scroll-snap-align: start;
    width: 100%;
    padding: 5px 20px;
}

.brand-card {
    display: flex;
    padding: 0 5px;
    align-items: center;
    text-align: center;
    font-size: 11px;
    gap: 10px;
    cursor: pointer;
}

.brand-card img {
    width: 50px;
    height: 50px;
    border-radius: 40%;
    object-fit: cover;
    border: 1px solid #f9f9f9;
}

.brand-label {
    font-weight: bold;
    color: #000;
    margin-bottom: 2px;
    font-size: 13px;
    text-align: left;
}

.brand-desc {
    color: #888;
    font-size: 12px;
    text-align: left;
}

.slide-indicator {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-top: 8px;
}

.slide-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #ddd;
    transition: background-color 0.3s ease;
}

.slide-dot.active {
    background-color: #000;
}

@keyframes spin-left {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(-360deg);
    }
}

.spin-left {
    animation: spin-left 2s linear;
}

.skeleton {
    background-color: #e0e0e0;
    border-radius: 4px;
}

/* optional: 빛나는 애니메이션 효과 */
@keyframes shimmer {
    0% {
        background-position: -200px 0;
    }

    100% {
        background-position: 200px 0;
    }
}

.skeleton {
    background: linear-gradient(90deg,
            #f5f5f5 25%,
            #ebebeb 50%,
            #f5f5f5 75%);
    background-size: 400px 100%;
    animation: shimmer 1.5s infinite;
}

/* skeleton 영역 크기 맞추기 */
.category-item.skeleton {
    width: 45px;
    height: 58px;
    margin: 0 auto;
}

.brand-card.skeleton {
    height: 58px;
}

.textarea-placeholder::placeholder {
    font-size: 14px;
    color: #f0f0f0;
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

.brand-swiper {
    width: 100%;
}

.brand-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    align-items: stretch;
}

.brand-swiper .swiper-pagination-bullet {
    width: 6px;
    /* 원하는 크기 */
    height: 6px;
}

.swiper-pagination {
    bottom: 0 !important;
}


.category-swiper {
    width: 100%;
}

/* 5 x 3 그리드 */
.category-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-auto-rows: 78px;
    gap: 10px 5px;
    height: 100%;
    align-items: stretch;
}

.category-swiper .swiper-pagination-bullet {
    width: 6px;
    /* 원하는 크기 */
    height: 6px;
}

.category-name {
    font-size: 12px;
    width: 60px;
}

.category-swiper .my-bullet,
.brand-swiper .my-bullet {
    width: 6px;
    height: 6px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 50%;
    display: inline-block;
    margin: 0 4px;
}

.category-swiper .my-bullet.my-bullet-active,
.brand-swiper .my-bullet.my-bullet-active {
    background: #007AFF;
}`, "",{"version":3,"sources":["webpack://./src/Pages/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,4BAA4B;IAC5B,uCAAuC;IACvC,kBAAkB;IAClB,qDAAqD;IACrD,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB;mBACe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI;QACI,4BAA4B;QAC5B,cAAc;QACd,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,2BAA2B;QAC3B,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;QACxB,cAAc;IAClB;AACJ;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,yBAAiB;YAAjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,UAAU;QACV,6BAA6B;IACjC;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,eAAe;IACf,OAAO;IACP,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,oBAAoB;AACxB;;;AAGA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,sCAAsC;IACtC,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA,oBAAoB;;AAEpB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,4CAA4C;IAC5C,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,uBAAuB;IACvB,uCAAuC;IACvC,WAAW;;IAEX,6BAA6B;IAC7B,4BAA4B;IAC5B,uCAAuC;IACvC,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,kBAAkB;IAClB,uCAAuC;IACvC,qDAAqD;IACrD,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,cAAc;IACd,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA,mBAAmB;;AAEnB;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA,gBAAgB;;AAEhB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;;AAGA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,YAAY;IACZ,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,MAAM;IACN,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iDAAiD;AACrD;;AAEA;IACI,kDAAkD;IAClD,qCAAqC;IACrC,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,QAAQ;IACR,SAAS;IACT,2BAA2B;AAC/B;;;;;;;AAOA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,WAAW;AACX;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,aAAa;IACb,qCAAqC;IACrC,mCAAmC;IACnC,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,+BAA+B;IAC/B,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,sBAAsB;IACtB,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,mCAAmC;IACnC,cAAc;IACd,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,qCAAqC;IACrC,mCAAmC;IACnC,aAAa;IACb,wBAAwB;IACxB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,2BAA2B;AAC3B;IACI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;;;wBAGoB;IACpB,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI,WAAW;AACf;;AAEA,cAAc;AACd;IACI,aAAa;IACb,qCAAqC;IACrC,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;;IAEI,mBAAmB;AACvB","sourcesContent":[".main {\r\n    width: 100%;\r\n    height: calc(100vh);\r\n    padding-top: 105px;\r\n    padding-bottom: 60px;\r\n    overflow: hidden;\r\n    background-color: var(--color-black);\r\n    position: relative;\r\n}\r\n\r\n.main.notheader {\r\n    padding-top: 20px;\r\n}\r\n\r\n.main-box {\r\n    width: 100%;\r\n    height: 100%;\r\n    padding: 15px 20px;\r\n    border-top-right-radius: 35px;\r\n    border-top-left-radius: 35px;\r\n    border-top: 2px solid var(--main-color);\r\n    position: relative;\r\n    box-shadow: 0px 3px 40px 10px var(--main-color-light);\r\n    z-index: 100;\r\n}\r\n\r\n.main-1 {\r\n    width: 100%;\r\n    font-size: 14px;\r\n}\r\n\r\n.main-1-1 {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 5px;\r\n}\r\n\r\n.main-ads {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 10px;\r\n    /* padding: 10px;\r\n    height: 90px; */\r\n    font-size: 9px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.main-2 {\r\n    width: 100%;\r\n    /* padding-top: 30px; */\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    height: calc(100vh - 290px);\r\n}\r\n\r\n.img_diamond {\r\n    width: 30px;\r\n}\r\n\r\n.main-2-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 5px;\r\n    font-size: 24px;\r\n}\r\n\r\n@keyframes bounceIn {\r\n    0% {\r\n        transform: translateY(-40px);\r\n        /* 화면 위에서 시작 */\r\n        opacity: 0;\r\n        /* 투명하게 시작 */\r\n    }\r\n\r\n    70% {\r\n        transform: translateY(10px);\r\n        opacity: 1;\r\n        /* 살짝 튕기듯 위로 올라감 */\r\n    }\r\n\r\n    100% {\r\n        transform: translateY(0);\r\n        /* 최종 위치에 도달 */\r\n    }\r\n}\r\n\r\n/* .main-2-header.aos-animate {\r\n    animation: bounceIn .2s ease-out;\r\n} */\r\n\r\n.main-2-img {\r\n    position: relative;\r\n    padding: 0;\r\n    /* padding: 10px 15px 0; */\r\n}\r\n\r\n.center-img {\r\n    outline: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n    user-select: none;\r\n    pointer-events: none;\r\n}\r\n\r\n.heart {\r\n    position: absolute;\r\n    width: 30px;\r\n    height: 30px;\r\n    animation: floatUp 1s ease-in-out forwards;\r\n    z-index: 11;\r\n    pointer-events: none;\r\n}\r\n\r\n.heart.number {\r\n    font-size: 30px;\r\n    font-weight: bold;\r\n}\r\n\r\n/* 위로 떠오르는 애니메이션 */\r\n@keyframes floatUp {\r\n    0% {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n        transform: translateY(-100px);\r\n    }\r\n}\r\n\r\n.main-3 {\r\n    width: 100%;\r\n    padding: 5px 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    position: fixed;\r\n    left: 0;\r\n    bottom: 75px;\r\n    padding: 5px 30px;\r\n}\r\n\r\n.main-3-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.main-3-1-img {\r\n    width: 25px;\r\n}\r\n\r\n.page-img {\r\n    width: 100%;\r\n}\r\n\r\n.hamster-img {\r\n    width: 50%;\r\n    min-width: 180px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 10;\r\n    pointer-events: none;\r\n}\r\n\r\n\r\n.settings {\r\n    padding: 0 15px;\r\n    width: 100%;\r\n}\r\n\r\n.settings-header {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.settings-list {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 15px;\r\n    margin-bottom: 10px;\r\n    height: 55px;\r\n    padding: 0 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n}\r\n\r\n.settings-list.active {\r\n    border: 1px solid var(--color-light-gray);\r\n}\r\n\r\n.settings-list.disable {\r\n    filter: blur(2px);\r\n}\r\n\r\n.settings-list-icon {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 20px;\r\n}\r\n\r\n.settings-list-text1 {\r\n    color: var(--color-white);\r\n    font-weight: 500;\r\n    font-size: 13px;\r\n}\r\n\r\n.settings-list-text2 {\r\n    font-size: 12px;\r\n    color: var(--color-light-gray);\r\n}\r\n\r\n.settings-list-text3 {\r\n    color: var(--color-white);\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n    margin-bottom: 10px;\r\n    text-align: left;\r\n    padding: 10px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.settings-list-text3.active {\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 15px;\r\n}\r\n\r\n.settings-list-download {\r\n    width: 100%;\r\n    height: 100px;\r\n    background-color: var(--color-white);\r\n    border-radius: 15px;\r\n    padding: 5px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n}\r\n\r\n.settings-toggle {\r\n    width: 100%;\r\n    height: 40px;\r\n    padding: 0 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n}\r\n\r\n.toggle-box {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n}\r\n\r\n.toggle-box-on {\r\n    position: absolute;\r\n    color: var(--color-white);\r\n    top: 50%;\r\n    left: 16px;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.toggle-box-off {\r\n    position: absolute;\r\n    color: var(--color-darkest-gray);\r\n    top: 50%;\r\n    right: 16px;\r\n    transform: translateY(-50%);\r\n}\r\n\r\n.toggle-box {\r\n    width: 45px;\r\n    height: 22px;\r\n    display: block;\r\n    position: relative;\r\n    border-radius: 30px;\r\n    color: var(--color-white);\r\n    background: var(--color-light-gray-bg);\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n}\r\n\r\n.toggle-box-btn {\r\n    transition: all .2s ease-in-out;\r\n    width: 19px;\r\n    height: 19px;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 2px;\r\n    transform: translateY(-50%);\r\n    border-radius: 50%;\r\n    background: var(--main-color-accent);\r\n}\r\n\r\n.toggled {\r\n    background-color: var(--main-color-accent);\r\n}\r\n\r\n.toggled .toggle-box-btn.slider {\r\n    transition: all .2s ease-in-out;\r\n    left: calc(100% - 22px);\r\n    background: var(--color-white);\r\n}\r\n\r\n.settings-subheader {\r\n    font-size: 16px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.memories-list {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 8px 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n}\r\n\r\n.memories-list-text {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n}\r\n\r\n.settings-body {\r\n    width: 100%;\r\n    height: calc(100vh - 180px);\r\n    overflow: scroll;\r\n}\r\n\r\n.friend {\r\n    padding: 0 15px;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* padding-bottom: 75px; */\r\n    overflow: scroll;\r\n}\r\n\r\n.memories {\r\n    padding: 0 15px 25px;\r\n    width: 100%;\r\n    height: calc(100vh - 63px);\r\n    overflow: scroll;\r\n}\r\n\r\n.airdrop-body {\r\n    width: 100%;\r\n    height: calc(100vh - 60px);\r\n    padding-top: 400px;\r\n    overflow: auto;\r\n    padding: 0 15px 10px;\r\n}\r\n\r\n.memories-body {\r\n    width: 100%;\r\n    height: calc(100vh - 180px);\r\n    overflow: scroll;\r\n}\r\n\r\n.airdrop-tab {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: var(--color-dark-gray);\r\n    padding: 5px;\r\n    height: 50px;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.airdrop-tab-item {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 5px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n}\r\n\r\n.airdrop-tab-item.active {\r\n    background-color: var(--color-charcoal);\r\n}\r\n\r\n.airdrop-input {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.airdrop-input-box-1 {\r\n    width: 100%;\r\n    text-align: left;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.airdrop-input-box-2 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.airdrop-input-box-2-1 {\r\n    background-color: inherit;\r\n    outline: none;\r\n    color: var(--color-white);\r\n    padding: 0 10px;\r\n    border: 1px solid var(--color-gray);\r\n    height: auto;\r\n    /* 높이를 내용에 따라 자동 조정 */\r\n    min-height: 30px;\r\n    /* 최소 높이 설정 */\r\n    border-radius: 5px;\r\n    width: calc(100%);\r\n    /* 100% 너비 */\r\n    font-size: 12px;\r\n    line-height: 30px;\r\n    /* 줄 높이 */\r\n    white-space: normal;\r\n    /* 텍스트 줄바꿈 허용 */\r\n    word-break: break-word;\r\n    /* 단어 단위로 줄바꿈 */\r\n}\r\n\r\n.airdrop-box {\r\n    width: 100%;\r\n    padding: 25px 20px;\r\n    background-color: var(--color-dark-gray);\r\n    margin-bottom: 20px;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n}\r\n\r\n.airdrop-box-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    height: 20px;\r\n    font-size: 13px;\r\n    gap: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.airdrop-box-item .dots {\r\n    height: 100%;\r\n    flex-grow: 1;\r\n    border-bottom: 2px dotted var(--color-gray);\r\n}\r\n\r\n.airdrop-box-item .number {\r\n    font-size: 20px;\r\n    font-weight: 500;\r\n}\r\n\r\n.airdrop-box-list {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 10px 20px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n}\r\n\r\n.airdrop-list-text {}\r\n\r\n.airdrop-icon {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 15px;\r\n    font-size: 27px;\r\n    color: var(--color-gray);\r\n}\r\n\r\n.airdrop-list-text2 {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: var(--color-black-opacity);\r\n    z-index: 10000;\r\n}\r\n\r\n.modal-background {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.airdrop-modal {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    padding: 40px 15px 20px;\r\n    background-color: var(--color-charcoal);\r\n    z-index: 10;\r\n\r\n    border-top-right-radius: 35px;\r\n    border-top-left-radius: 35px;\r\n    border-top: 2px solid var(--main-color);\r\n    box-shadow: 0px 0px 70px 10px var(--main-color-light);\r\n}\r\n\r\n.modal-x {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 20px;\r\n    font-size: 23px;\r\n    color: var(--color-gray);\r\n}\r\n\r\n.modal-airdrop-btn {\r\n    width: 100%;\r\n    height: 50px;\r\n    border-radius: 10px;\r\n    background-color: var(--main-color-alt);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.character {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-top: 2px solid var(--main-color);\r\n    position: relative;\r\n    background-color: var(--color-charcoal);\r\n    box-shadow: 0px 3px 40px 10px var(--main-color-light);\r\n    border-top-right-radius: 35px;\r\n    border-top-left-radius: 35px;\r\n    padding: 15px;\r\n    display: flex;\r\n    gap: 10px;\r\n    z-index: 100;\r\n}\r\n\r\n.character-left {\r\n    width: 70%;\r\n}\r\n\r\n.character-left-top {\r\n    padding: 10px;\r\n    height: calc(100vh - 350px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.character-left-top img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n    background-color: var(--color-charcoal);\r\n}\r\n\r\n.character-left-bottom {\r\n    width: 100%;\r\n    padding: 10px;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n}\r\n\r\n.charcter-left-btn {\r\n    width: 100%;\r\n    height: 60px;\r\n    background-color: var(--main-color-dark);\r\n    border-radius: 15px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n}\r\n\r\n.character-right {\r\n    width: 30%;\r\n    /* min-width: 100px; */\r\n}\r\n\r\n.character-grid {\r\n    display: grid;\r\n    box-sizing: border-box;\r\n    grid-template-columns: 1fr;\r\n    /* 두 열 고정 비율 */\r\n    gap: 7px;\r\n    overflow-y: auto;\r\n    height: auto;\r\n    max-height: calc(100vh - 200px);\r\n    padding-top: 5px;\r\n    padding-right: 5px;\r\n}\r\n\r\n.character-card {\r\n    position: relative;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 10px;\r\n    padding: 15px 0px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    text-align: center;\r\n    color: var(--color-white);\r\n}\r\n\r\n.character-card.active {\r\n    border: 1px solid var(--main-color-light);\r\n}\r\n\r\n.character-image {\r\n    width: 80%;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.character-name {\r\n    font-size: 10px;\r\n    color: var(--color-light-gray);\r\n    font-weight: 500;\r\n}\r\n\r\n.lock-icon {\r\n    position: absolute;\r\n    top: -5px;\r\n    right: -2px;\r\n    font-size: 15px;\r\n    color: var(--color-light-gray);\r\n}\r\n\r\n.lock-check {\r\n    position: absolute;\r\n    top: -5px;\r\n    right: -5px;\r\n    font-size: 15px;\r\n}\r\n\r\n.friend-list-text {}\r\n\r\n.friend-list-text-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    font-size: 12px;\r\n}\r\n\r\n.friend-list {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 8px 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.friend-list-1 {}\r\n\r\n.friend-list-1-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.friend-list-1-2 {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 8px 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 70px;\r\n    font-weight: 500;\r\n    color: var(--color-light-gray);\r\n}\r\n\r\n.friend-list-1-3 {\r\n    width: 100%;\r\n    background-color: var(--color-dark-gray);\r\n    border-radius: 20px;\r\n    margin-bottom: 10px;\r\n    padding: 8px 15px;\r\n    text-align: left;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    /* height: 70px; */\r\n    font-weight: 500;\r\n}\r\n\r\n.friend-list-1-3-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.friend-list-1-3-2 {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n\r\n.friend-list-2 {\r\n    position: absolute;\r\n    bottom: 80px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: calc(100% - 30px);\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n}\r\n\r\n.friend-list-2-1 {\r\n    width: calc(100% - 50px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n}\r\n\r\n.friend-list-2-btn {\r\n    width: calc(100% - 10px);\r\n    height: 45px;\r\n    border-radius: 15px;\r\n    background-color: var(--main-color-light);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.friend-list-2-icon {\r\n    width: 50px;\r\n    height: 45px;\r\n    border-radius: 15px;\r\n    background-color: var(--main-color-accent);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.setting-sns {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 12px;\r\n    position: absolute;\r\n    bottom: 80px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n\r\n.table-overflow-hidden {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block !important;\r\n}\r\n\r\n.table-overflow-1line {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.table-overflow-2lines {\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    word-break: break-all;\r\n}\r\n\r\n.random {\r\n    width: calc(100% - 80px);\r\n    position: absolute;\r\n    bottom: 30px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n.random .random-buttons {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    width: 100%;\r\n}\r\n\r\n.random .random-button {\r\n    padding: 10px 30px;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    border: none;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    width: calc(100% - 20px);\r\n    height: 45px;\r\n    color: var(--color-black);\r\n    background-color: var(--main-color-light);\r\n}\r\n\r\n.random .random-button.disable {\r\n    background-color: var(--color-light-gray);\r\n}\r\n\r\n.item-previews {\r\n    display: flex;\r\n    justify-content: space-around;\r\n    margin-bottom: 10px;\r\n    gap: 4px;\r\n    overflow: hidden;\r\n    width: 100%;\r\n}\r\n\r\n.random-item {\r\n    width: 100%;\r\n    height: 100px;\r\n    padding: 10px 15px;\r\n    font-size: 16px;\r\n    text-align: center;\r\n    color: var(--color-white);\r\n    background-color: transparent;\r\n    border: 1px solid transparent;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.random-item.selected {\r\n    border: 1px solid var(--color-yellow);\r\n    background-color: var(--color-black-brown);\r\n}\r\n\r\n.random-info {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.randombox-bg {\r\n    width: 100%;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    transform: translateY(-50%);\r\n    z-index: 0;\r\n    object-fit: cover;\r\n    border-radius: 50px;\r\n    filter: grayscale(0.5);\r\n}\r\n\r\n.main-box-randombox {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n    z-index: 1000;\r\n    top: 0;\r\n    background-color: var(--color-black);\r\n    display: flex;\r\n}\r\n\r\n.randombox-clear {\r\n    padding: 30px 15px;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow: scroll;\r\n    background-color: var(--color-black-opacity-dark);\r\n}\r\n\r\n.randombox-clear-1 {\r\n    background-color: var(--color-black-opacity-light);\r\n    border: 2px solid var(--color-orange);\r\n    border-radius: 10px;\r\n    width: 95px;\r\n    height: 90px;\r\n    margin: 80px auto 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.video {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    pointer-events: none;\r\n    position: fixed;\r\n    z-index: 1000;\r\n    top: -7%;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.coupons-tab {\r\n    display: flex;\r\n    gap: 15px;\r\n    font-size: 15px;\r\n}\r\n\r\n.coupons-tab-btn {\r\n    padding: 5px 0;\r\n    cursor: pointer;\r\n    color: #666;\r\n    font-weight: bold;\r\n    position: relative;\r\n}\r\n\r\n.coupons-tab-btn.active {\r\n    color: #000;\r\n    /* 밑줄 대신 노란색 바 */\r\n    border-bottom: 2px solid #ffbb3f;\r\n}\r\n\r\n/* 스크롤 영역 */\r\n.coupons-grid-scroll {\r\n    max-height: calc(100dvh - 150px);\r\n    overflow-y: auto;\r\n}\r\n\r\n/* 2열 그리드 */\r\n.coupons-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 20px 7px;\r\n    padding-bottom: 60px;\r\n}\r\n\r\n.coupon-item {\r\n    background-color: #fff;\r\n    overflow: hidden;\r\n    transition: opacity 0.3s;\r\n    display: flex;\r\n    flex-direction: column;\r\n    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\r\n    position: relative;\r\n}\r\n\r\n.coupon-image-wrapper {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 0;\r\n    padding-bottom: 100%;\r\n    /* 1:1 정사각형 비율 */\r\n    overflow: hidden;\r\n}\r\n\r\n.coupon-image-wrapper.used {\r\n    opacity: 0.6;\r\n    /* 사용완료/사용불가 시 흐리게 */\r\n}\r\n\r\n.d-day-badge {\r\n    position: absolute;\r\n    background: #a0a0a0;\r\n    /* 회색 배경 */\r\n    color: #fff;\r\n    padding: 3px 6px;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    z-index: 2;\r\n    top: 1px;\r\n    left: 1px;\r\n}\r\n\r\n.coupon-image {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    border: 1px solid #f9f9f9;\r\n    border-radius: 5px;\r\n}\r\n\r\n/* 사용완료/사용불가 구분 */\r\n.used-type-badge {\r\n    position: absolute;\r\n    bottom: 5px;\r\n    right: 5px;\r\n    padding: 3px 6px;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    color: #fff;\r\n    z-index: 2;\r\n}\r\n\r\n.used-type-badge.complete {\r\n    background: rgba(128, 128, 128, 0.7);\r\n}\r\n\r\n.used-type-badge.not-available {\r\n    background: rgba(255, 0, 0, 0.7);\r\n}\r\n\r\n.coupon-info {\r\n    padding: 5px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n}\r\n\r\n.coupon-company {\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    color: #79a2c9;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.coupon-title {\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin-bottom: 7px;\r\n    color: #919191;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.coupon-from {\r\n    font-size: 14px;\r\n    color: #000;\r\n    font-weight: bold;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.coupon-date {\r\n    font-size: 11px;\r\n    color: #9b9b9b;\r\n    width: 100%;\r\n    text-align: left;\r\n}\r\n\r\n.shopping-nav {\r\n    margin-top: 50px;\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #dddddd;\r\n}\r\n\r\n.shopping-nav ul {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    margin: 0;\r\n    padding: 0 10px;\r\n    list-style-type: none;\r\n    gap: 10px;\r\n}\r\n\r\n.shopping-nav li {\r\n    padding: 10px 6px;\r\n    white-space: nowrap;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    cursor: pointer;\r\n}\r\n\r\n.shopping-nav li.active {\r\n    border-bottom: 2px solid #000;\r\n}\r\n\r\n.tab-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    background-color: #f1f1f1;\r\n    padding: 2px;\r\n    border-radius: 30px;\r\n    width: fit-content;\r\n    margin: 0px auto 15px;\r\n}\r\n\r\n.tab-button {\r\n    padding: 7px 0px;\r\n    border: none;\r\n    background-color: transparent;\r\n    border-radius: 30px;\r\n    font-size: 14px;\r\n    color: #555;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    transition: background-color 0.2s ease;\r\n    width: 100px;\r\n    height: 34px;\r\n}\r\n\r\n.tab-button.active {\r\n    background-color: white;\r\n    color: black;\r\n    font-weight: 700;\r\n    box-shadow: 0 0 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.gift-scroll-container {\r\n    width: 100%;\r\n    background: #f5f5f5;\r\n    padding: 15px 15px;\r\n}\r\n\r\n.gift-scroll-container::-webkit-scrollbar {\r\n    display: none;\r\n    /* Chrome, Safari */\r\n}\r\n\r\n.category-slide-wrapper {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    scroll-snap-type: x mandatory;\r\n    gap: 12px;\r\n}\r\n\r\n.category-slide {\r\n    flex: 0 0 auto;\r\n    width: 100%;\r\n    height: 250px;\r\n    display: grid;\r\n    grid-template-columns: repeat(5, 1fr);\r\n    grid-template-rows: repeat(3, 70px);\r\n    gap: 18px 5px;\r\n    scroll-snap-align: start;\r\n}\r\n\r\n.category-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    font-size: 13px;\r\n    color: #222;\r\n    cursor: pointer;\r\n    margin: 0 auto;\r\n    max-width: 60px;\r\n}\r\n\r\n.category-item img {\r\n    width: 48px;\r\n    height: 48px;\r\n    object-fit: cover;\r\n    border-radius: 40%;\r\n    margin-bottom: 5px;\r\n    /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\r\n    /* background-color: #f5f5f5; */\r\n    border: 1px solid #f9f9f9;\r\n    padding: 2px;\r\n}\r\n\r\n.brand-scroll-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\r\n    grid-auto-flow: column;\r\n    grid-template-rows: repeat(2, auto);\r\n    overflow-x: auto;\r\n    gap: 16px 12px;\r\n    padding: 10px 12px;\r\n    scroll-snap-type: x mandatory;\r\n}\r\n\r\n.brand-slide-wrapper {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    scroll-snap-type: x mandatory;\r\n    gap: 16px;\r\n}\r\n\r\n.brand-slide {\r\n    flex: 0 0 auto;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-template-rows: repeat(4, 54px);\r\n    gap: 10px 10px;\r\n    scroll-snap-align: start;\r\n    width: 100%;\r\n}\r\n\r\n.brand-list-slide {\r\n    flex: 0 0 auto;\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    grid-template-rows: repeat(2, 54px);\r\n    gap: 7px 10px;\r\n    scroll-snap-align: start;\r\n    width: 100%;\r\n    padding: 5px 20px;\r\n}\r\n\r\n.brand-card {\r\n    display: flex;\r\n    padding: 0 5px;\r\n    align-items: center;\r\n    text-align: center;\r\n    font-size: 11px;\r\n    gap: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n.brand-card img {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 40%;\r\n    object-fit: cover;\r\n    border: 1px solid #f9f9f9;\r\n}\r\n\r\n.brand-label {\r\n    font-weight: bold;\r\n    color: #000;\r\n    margin-bottom: 2px;\r\n    font-size: 13px;\r\n    text-align: left;\r\n}\r\n\r\n.brand-desc {\r\n    color: #888;\r\n    font-size: 12px;\r\n    text-align: left;\r\n}\r\n\r\n.slide-indicator {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 6px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.slide-dot {\r\n    width: 6px;\r\n    height: 6px;\r\n    border-radius: 50%;\r\n    background-color: #ddd;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.slide-dot.active {\r\n    background-color: #000;\r\n}\r\n\r\n@keyframes spin-left {\r\n    from {\r\n        transform: rotate(0deg);\r\n    }\r\n\r\n    to {\r\n        transform: rotate(-360deg);\r\n    }\r\n}\r\n\r\n.spin-left {\r\n    animation: spin-left 2s linear;\r\n}\r\n\r\n.skeleton {\r\n    background-color: #e0e0e0;\r\n    border-radius: 4px;\r\n}\r\n\r\n/* optional: 빛나는 애니메이션 효과 */\r\n@keyframes shimmer {\r\n    0% {\r\n        background-position: -200px 0;\r\n    }\r\n\r\n    100% {\r\n        background-position: 200px 0;\r\n    }\r\n}\r\n\r\n.skeleton {\r\n    background: linear-gradient(90deg,\r\n            #f5f5f5 25%,\r\n            #ebebeb 50%,\r\n            #f5f5f5 75%);\r\n    background-size: 400px 100%;\r\n    animation: shimmer 1.5s infinite;\r\n}\r\n\r\n/* skeleton 영역 크기 맞추기 */\r\n.category-item.skeleton {\r\n    width: 45px;\r\n    height: 58px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.brand-card.skeleton {\r\n    height: 58px;\r\n}\r\n\r\n.textarea-placeholder::placeholder {\r\n    font-size: 14px;\r\n    color: #f0f0f0;\r\n}\r\n\r\n@keyframes fadeOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n\r\n.brand-swiper {\r\n    width: 100%;\r\n}\r\n\r\n.brand-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 10px;\r\n    align-items: stretch;\r\n}\r\n\r\n.brand-swiper .swiper-pagination-bullet {\r\n    width: 6px;\r\n    /* 원하는 크기 */\r\n    height: 6px;\r\n}\r\n\r\n.swiper-pagination {\r\n    bottom: 0 !important;\r\n}\r\n\r\n\r\n.category-swiper {\r\n    width: 100%;\r\n}\r\n\r\n/* 5 x 3 그리드 */\r\n.category-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(5, 1fr);\r\n    grid-auto-rows: 78px;\r\n    gap: 10px 5px;\r\n    height: 100%;\r\n    align-items: stretch;\r\n}\r\n\r\n.category-swiper .swiper-pagination-bullet {\r\n    width: 6px;\r\n    /* 원하는 크기 */\r\n    height: 6px;\r\n}\r\n\r\n.category-name {\r\n    font-size: 12px;\r\n    width: 60px;\r\n}\r\n\r\n.category-swiper .my-bullet,\r\n.brand-swiper .my-bullet {\r\n    width: 6px;\r\n    height: 6px;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    border-radius: 50%;\r\n    display: inline-block;\r\n    margin: 0 4px;\r\n}\r\n\r\n.category-swiper .my-bullet.my-bullet-active,\r\n.brand-swiper .my-bullet.my-bullet-active {\r\n    background: #007AFF;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
